// Redux Utils
import { useSelector, useDispatch } from "react-redux";
import { useEmpresaForm } from "@/hooks/useEmpresaForm";
import { useEffect } from "react";

// Assets
import LogoPerfilEmpresa from "@/assets/Logo-AppWhoop.webp";
import userGeneric from "@/assets/avatars/avatar-generic.webp";

// Components
import Portada from "@/components/Perfil/Portada";
import InfoPerfil from "@/components/Perfil/InfoPerfil";
import OptionsPerfil from "@/components/Perfil/OptionsPerfil";
import StatsPerfil from "@/components/Perfil/StatsPerfil";
import TicketCarousel from "@/components/TicketCarousel/TicketCarousel";
import InfoSeparacionEmpresa from "@/components/Perfil/InfoSeparacionEmpresa";
import UbicacionEmpresaOptions from "@/components/Perfil/UbicacionEmpresaOptions";
import AvatarCarousel from "@/components/AvatarCarousel";
import OptionsJoinEmpresa from "@/components/Perfil/OptionsJoinEmpresa";
import RespaldoAppWhoop from "@/components/Perfil/RespaldoAppWhoop";
import TicketCardPerfilEmpresa from "@/components/TicketCarousel/TicketCardPerfilEmpresa";

// Demo tickets data
const tickets = [
  {
    id: 1,
    dateTime: "Lunes 20 de Mes - 19:00 hrs",
    title: "-------",
    discount: true,
    location: "--------",
  },
  {
    id: 2,
    dateTime: "Martes 20 de Mes - 19:00 hrs",
    title: "-------",
    discount: true,
    location: "--------",
  },
  {
    id: 3,
    dateTime: "Miércoles 20 de Mes - 19:00 hrs",
    title: "-------",
    discount: true,
    location: "--------",
  },
  {
    id: 4,
    dateTime: "Jueves 20 de Mes - 19:00 hrs",
    title: "-------",
    discount: true,
    location: "--------",
  },
  {
    id: 5,
    dateTime: "Viernes 20 de Mes - 19:00 hrs",
    title: "-------",
    discount: true,
    location: "--------",
  },
  {
    id: 6,
    dateTime: "Sábado 20 de Mes - 19:00 hrs",
    title: "-------",
    discount: true,
    location: "--------",
  },
  {
    id: 7,
    dateTime: "Domingo 20 de Mes - 19:00 hrs",
    title: "-------",
    discount: true,
    location: "--------",
  },
  {
    id: 8,
    dateTime: "Lunes 20 de Mes - 19:00 hrs",
    title: "-------",
    discount: true,
    location: "--------",
  },
  {
    id: 9,
    dateTime: "Martes 20 de Mes - 19:00 hrs",
    title: "-------",
    discount: true,
    location: "--------",
  },
  {
    id: 10,
    dateTime: "Miércoles 20 de Mes - 19:00 hrs",
    title: "-------",
    discount: true,
    location: "--------",
  },
  {
    id: 11,
    dateTime: "Jueves 20 de Mes - 19:00 hrs",
    title: "-------",
    discount: true,
    location: "--------",
  },
  {
    id: 12,
    dateTime: "Viernes 20 de Mes - 19:00 hrs",
    title: "-------",
    discount: true,
    location: "--------",
  },
  {
    id: 13,
    dateTime: "Sábado 20 de Mes - 19:00 hrs",
    title: "-------",
    discount: true,
    location: "--------",
  },
  {
    id: 14,
    dateTime: "Domingo 20 de Mes - 19:00 hrs",
    title: "-------",
    discount: true,
    location: "--------",
  },
];

// Sample avatar data
const sampleAvatars = [
  {
    id: 1,
    src: userGeneric,
    name: "Persona 1",
    role: "Lider de Staff",
  },
  {
    id: 2,
    src: userGeneric,
    name: "Persona 2",
    role: "Staff",
  },
  {
    id: 3,
    src: userGeneric,
    name: "Persona 3",
    role: "Staff",
  },
  {
    id: 4,
    src: userGeneric,
    name: "Christopher Ferrada",
    role: "Líder de Staff",
  },
  {
    id: 5,
    src: userGeneric,
    name: "Persona 5",
    role: "Staff",
  },
  {
    id: 6,
    src: userGeneric,
    name: "Persona 6",
    role: "Staff",
  },
  {
    id: 7,
    src: userGeneric,
    name: "Persona 7",
    role: "Staff",
  },
];

const seguidoresInfo = {
  seguidores: [
    {
      nombre: "",
      apellido: "",
      alias: null,
      imgPerfil: null,
    },
    {
      nombre: "",
      apellido: "",
      alias: null,
      imgPerfil: null,
    },
    {
      nombre: "",
      apellido: "",
      alias: null,
      imgPerfil: null,
    },
    {
      nombre: "",
      apellido: "",
      alias: null,
      imgPerfil: null,
    },
    {
      nombre: "",
      apellido: "",
      alias: null,
      imgPerfil: null,
    },
    {
      nombre: "",
      apellido: "",
      alias: null,
      imgPerfil: null,
    },
    {
      nombre: "",
      apellido: "",
      alias: null,
      imgPerfil: null,
    },
  ],
};

// Sample menu options
const menuOptions = [
  {
    type: "none",
    classContent: "bg-aw-bluedark p-1.5",
  },
];

export default function CrearPerfilEmpresa() {
  const dispatch = useDispatch();
  const { formData } = useEmpresaForm();
  let info = useSelector((state) => state.crearEmpresa.infoCrearEmpresa);

  // Limpiar URLs de objeto cuando el componente se desmonte
  useEffect(() => {
    return () => {
      // Limpiar URLs de objeto para evitar memory leaks
      if (formData.portada && typeof formData.portada === 'object') {
        URL.revokeObjectURL(URL.createObjectURL(formData.portada));
      }
      if (formData.imagenperfil && typeof formData.imagenperfil === 'object') {
        URL.revokeObjectURL(URL.createObjectURL(formData.imagenperfil));
      }
    };
  }, [formData.portada, formData.imagenperfil]);

  // Combinar datos del formulario con datos base
  const empresaInfo = {
    imgPortada: formData.portada ? 
      (typeof formData.portada === 'string' ? formData.portada : URL.createObjectURL(formData.portada)) 
      : null,
    imgPerfil: formData.imagenperfil ? 
      (typeof formData.imagenperfil === 'string' ? formData.imagenperfil : URL.createObjectURL(formData.imagenperfil))
      : LogoPerfilEmpresa,
    embajadores: [userGeneric, userGeneric, userGeneric, userGeneric],
    nombre: formData.nombre || "Empresa",
    categoria: formData.categoria || "Categoría",
    typeProfile: "Empresa",
    // Ordenar dirección para que se lea, Dirección, Comuna, Ciudad, País
    direccion: formData.direccion || formData.comuna || formData.ciudad || formData.pais ? 
      `${formData?.direccion}${formData?.comuna ? `, ${formData?.comuna}` : ''}${formData?.ciudad ? `, ${formData?.ciudad}` : ''}${formData?.pais ? `, ${formData?.pais}` : ''}` 
      : "Dirección, Comuna, Ciudad, País",
    myself: false, // Para que se muestren los controles de edición
    statsList: [
      {
        statName: "Data",
        icon: null,
        colorName: "gray-200",
        stats: [
          {
            count: "-.---",
            label: "Visitas",
          },
        ],
      },
      {
        statName: "Tipo Perfil",
        icon: null,
        colorName: "gray-200",
        stats: [
          {
            count: "---",
            label: "Ticket Vendidos",
          },
        ],
      },
      {
        statName: "Destacado",
        icon: "medal",
        colorName: "amber-400",
        stats: [
          {
            count: "--.---",
            label: "Seguidores",
          },
          {
            count: "-.---",
            label: "Seguidos",
          },
        ],
      },
    ],
    infoEmpresa: {
      alias: formData.nombre ? `@${formData.nombre.toLowerCase().replace(/\s+/g, '')}` : "- - - - -",
      rule1: formData.siubicacionfisica === 'Si' ? "Ubicación Física" : "Solo Digital",
      horario: formData.horario || "- - - - -",
      descripcion: formData.descripcion || "- - - - - - - - - -",
      redesSociales: [
        {
          url: "#",
          icon: "fa-brands fa-facebook",
        },
        {
          url: "#",
          icon: "fa-brands fa-instagram",
        },
        {
          url: "#",
          icon: "fa-brands fa-x-twitter",
        },
        {
          url: "#",
          icon: "fa-brands fa-tiktok",
        },
        {
          url: "#",
          icon: "fa-brands fa-youtube",
        },
        {
          url: "#",
          icon: "fa-brands fa-twitch",
        },
        {
          url: "#",
          icon: "fa-brands fa-spotify",
        },
        {
          url: "#",
          icon: "fa-brands fa-linkedin",
        },
        {
          url: "#",
          icon: "fa-brands fa-whatsapp",
        },
      ],
    },
    ubicacionInfo: {
      textUbicacion: "Dirección, Comuna, Ciudad, País",
      opcionesLlegada: [
        {
          url: null,
          label: "Pedir Uber",
        },
        {
          url: null,
          label: "Google Maps",
        },
        {
          url: null,
          label: "Ir por Waze",
        },
      ],
    },
  };
  
  // console.log("FormData en CrearPerfilEmpresa:", formData);
  // console.log("EmpresaInfo en CrearPerfilEmpresa:", empresaInfo);
  
  return (
    <>
      <div className="w-full max-w-5xl mx-auto relative">
        {/* Portada */}
        <Portada info={empresaInfo} />
      </div>
      <div className="w-full min-h-screen rounded-t-[5%] bg-aw-bluedark flex flex-col items-center pt-20 -mt-20 sm:-mt-[5.5rem]">
        {/* Content Perfil */}
        <div className="w-full max-w-5xl mx-auto relative">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-end opacity-50">
            {/* Información del Perfil */}
            <InfoPerfil info={empresaInfo} />
            {/* Opciones en Perfil */}
            <OptionsPerfil
              info={empresaInfo}
              people={seguidoresInfo}
              menuOptions={menuOptions}
            />
          </div>
        </div>
        {/* Stats Perfil */}
        <StatsPerfil stats={empresaInfo.statsList} />
        {/* Cartelera de Tickets Activos */}
        <div className="w-full mx-auto my-10 px-2">
          <h3 className="text-xl text-left font-semibold mb-3 text-white">
            Cartelera de Tickets
          </h3>
          <TicketCarousel
            tickets={tickets}
            TicketItem={TicketCardPerfilEmpresa}
          />
        </div>

        <>
          {/* Info de separación */}
          {/* <InfoSeparacionEmpresa info={info.infoEmpresa} /> */}
          {/* Tickets pasados */}
          <div className="w-full mx-auto my-10 px-2">
            <h3 className="text-xl text-left font-semibold mb-3 text-white">
              Tickets Pasados
            </h3>
            <TicketCarousel
              tickets={tickets}
              TicketItem={TicketCardPerfilEmpresa}
            />
          </div>
          {/* Ubicación y opciones Empresa*/}
          <div className="w-full flex flex-col items-center justify-center mb-12 px-4">
            <UbicacionEmpresaOptions info={empresaInfo.ubicacionInfo} />
          </div>
          <div className="w-full sm:w-1/2 lg:w-1/3">
            <AvatarCarousel
              avatars={sampleAvatars}
              autoRotate={true}
              rotateInterval={3000}
            />
          </div>
          <div className="w-full sm:w-3/4 lg:w-1/2 px-4 mb-6">
            <OptionsJoinEmpresa embajadores={empresaInfo.embajadores} />
          </div>
          <div className="w-3/4 px-4 mb-6">
            <RespaldoAppWhoop />
          </div>
        </>
      </div>
    </>
  );
}
